import { LinkedInSponsoredAccountUrn } from './urn'

export enum LinkedInCampaignGroupStatus {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    ARCHIVED = 'ARCHIVED',
    CANCELLED = 'CANCELLED',
    DRAFT = 'DRAFT',
    PENDING_DELETION = 'PENDING_DELETION',
    REMOVED = 'REMOVED',
}

export enum LinkedInCampaignGroupBidStrategy {
    MAXIMUM_DELIVERY = 'MAXIMUM_DELIVERY',
    MANUAL = 'MANUAL',
    COST_CAP = 'COST_CAP',
}

export enum LinkedInCampaignGroupBudgetOptimizationStrategy {
    DYNAMIC = 'DYNAMIC',
}

export type LinkedInCampaignGroup = {
    runSchedule: { start: number; end?: number }
    test: boolean
    changeAuditStamps: {
        created: { actor: string /**a urn but it's always urn:li:unknown:0 */; time: number }
        lastModified: { actor: string /**a urn but it's always urn:li:unknown:0 */; time: number }
    }
    name: string
    servingStatuses: string[]
    backfilled: boolean
    id: number
    account: LinkedInSponsoredAccountUrn
    status: LinkedInCampaignGroupStatus
    totalBudget?: { amount: string; currencyCode: string }
    // A bare decimal string in the account's currency, unlike totalBudget's Money object.
    dailyBudget?: string
    budgetOptimization?: {
        bidStrategy?: LinkedInCampaignGroupBidStrategy
        budgetOptimizationStrategy?: LinkedInCampaignGroupBudgetOptimizationStrategy
    }
    objectiveType?: string
    allowedCampaignTypes?: string[]
}

export type UpdateLinkedInCampaignGroupRequest = {
    patch: {
        $set: Partial<LinkedInCampaignGroup>
        // Field names to unset entirely — e.g. dropping totalBudget to revert to an unlimited budget.
        $delete?: (keyof LinkedInCampaignGroup)[]
    }
}
